module.exports = __webpack_public_path__ + "chat.f4b283c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/chat.png
// module id = 304
// module chunks = 0